// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.5 2H22.5V12.126C21.5149 11.4174 20.3062 11 19 11C15.6863 11 13 13.6863 13 17C13 17.3407 13.0284 17.6748 13.083 18H6.87573L1.5 22.7038V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.9987 13.6404V12.5H17.9987V13.6404C17.4657 13.799 16.9858 14.0813 16.5924 14.4538L15.6036 13.8829L14.6036 15.615L15.5928 16.1861C15.5313 16.4459 15.4987 16.7169 15.4987 16.9954C15.4987 17.2755 15.5316 17.5478 15.5937 17.8089L14.6035 18.3806L15.6035 20.1126L16.5954 19.5399C16.9883 19.9111 17.467 20.1923 17.9987 20.3505V21.4954H19.9987V20.3505C20.5304 20.1923 21.0091 19.9111 21.4019 19.54L22.3939 20.1127L23.3939 18.3806L22.4037 17.809C22.4658 17.5479 22.4987 17.2755 22.4987 16.9954C22.4987 16.7168 22.4662 16.4458 22.4046 16.186L23.3938 15.6149L22.3938 13.8828L21.4049 14.4538C21.0116 14.0812 20.5317 13.799 19.9987 13.6404ZM17.4987 16.9954C17.4987 16.167 18.1703 15.4954 18.9987 15.4954C19.8271 15.4954 20.4987 16.167 20.4987 16.9954C20.4987 17.8239 19.8271 18.4954 18.9987 18.4954C18.1703 18.4954 17.4987 17.8239 17.4987 16.9954Z"}}]};

const ChatSettingFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-setting-filled',
    ref,
    icon: element,
  },
));

ChatSettingFilledIcon.displayName = 'ChatSettingFilledIcon';

export default ChatSettingFilledIcon;
